/* SEASONS: sticky Add to cart bar on product pages (mobile only) */
(function () {
  function init() {
    var btn = document.querySelector('product-info .product-form__submit');
    if (!btn || document.querySelector('.ss-satc')) return;
    var info = btn.closest('product-info');
    var titleEl = info && (info.querySelector('.product__title h1') || info.querySelector('h1'));
    var priceWrap = info && info.querySelector('[id^="price-"]');

    var bar = document.createElement('div');
    bar.className = 'ss-satc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="ss-satc__info"><span class="ss-satc__title"></span><span class="ss-satc__price"></span></div><button type="button" class="ss-satc__btn">Add to cart</button>';
    document.body.appendChild(bar);
    var t = bar.querySelector('.ss-satc__title'), p = bar.querySelector('.ss-satc__price'), b = bar.querySelector('.ss-satc__btn');

    function sync() {
      if (titleEl) t.textContent = titleEl.textContent.trim();
      var price = '';
      if (priceWrap) {
        var sale = priceWrap.querySelector('.price--on-sale .price-item--sale');
        var cur = priceWrap.querySelector('.price-item--regular');
        var el = sale || cur;
        price = (el ? el.textContent : priceWrap.textContent).trim().replace(/\s+/g, ' ');
      }
      var opt = info && info.querySelector('variant-selects input:checked, variant-selects select');
      var optVal = opt ? (opt.tagName === 'SELECT' ? opt.value : opt.value) : '';
      p.textContent = price + (optVal && optVal !== 'Default Title' ? ' · ' + optVal : '');
      var label = btn.querySelector('span');
      b.textContent = label ? label.textContent.trim() : 'Add to cart';
      b.disabled = btn.disabled;
    }
    sync();
    if (priceWrap) new MutationObserver(sync).observe(priceWrap, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(btn, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    if (info) info.addEventListener('change', function () { setTimeout(sync, 50); });

    b.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.click();
    });

    var mq = window.matchMedia('(max-width: 749px)');
    var ticking = false;
    function check() {
      ticking = false;
      var r = btn.getBoundingClientRect();
      var on = mq.matches && r.bottom < 0;
      if (on === bar.classList.contains('is-on')) return;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('ss-satc-on', on);
    }
    function onScroll() {
      if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(check); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
